var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4678 0V27.4678C27.6052 27.5136 27.7883 27.4678 27.8798 27.4678H31.588C31.8169 27.4678 32 27.2847 32 27.0558V0.457797C32 0.183119 31.8169 0.0457797 31.588 0.0457797H27.422L27.4678 0ZM22.8898 2.28898L9.56795 9.0186C9.33906 9.11016 8.97282 9.15594 8.69814 9.15594H0.412017C0.137339 9.15594 0 9.33906 0 9.56795V17.8541C0 18.1288 0.183119 18.2661 0.412017 18.2661H4.57797L9.29328 30.7182C9.79685 31.8627 11.3076 32.3662 12.4521 31.8627C13.5966 31.3591 14.1001 29.8484 13.5966 28.7039L10.1631 20.5551C10.3004 19.9142 10.7582 19.5479 11.4449 19.5479V19.4106L22.8898 25.133V2.2432V2.28898Z",
    fill: "#3EC1D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.e0d5838ce2e290b70931b7f14d48d674.svg";
export { ForwardRef as ReactComponent };